import type { ICaaOrder } from "../interface/customer-account";
import useProductQuery from "../queries/useProductQuery";
import type { IUseCaaLineProductsProps } from "../types/hooks";
import { type TCaaLineProduct, getCaaLineProductIds } from "../utils/order";

/**
 * CAA 라인엔 상품 tags/metafield/compareAtPrice가 없어, 라인의 productId로 Storefront API에서 현재 상품을 조회
 */
export default function useCaaLineProducts({ lang, openToast }: IUseCaaLineProductsProps) {
  const { fetchProductsByIds } = useProductQuery({ lang, openToast });

  const fetchLineProducts = async (order: ICaaOrder): Promise<Map<string, TCaaLineProduct>> => {
    const productIds = getCaaLineProductIds(order);
    if (!productIds.length) return new Map();

    try {
      const data = await fetchProductsByIds({ ids: productIds });
      return new Map(data.nodes.filter((node): node is TCaaLineProduct => Boolean(node)).map((product) => [product.id, product]));
    } catch {
      return new Map();
    }
  };

  return { fetchLineProducts };
}
